import React from "react";

type Props = {
    src?: string;
    style?: React.CSSProperties;
};

export const CustomImage = ({ src, style }: Props) => <img src={src} style={style} />;
